<template lang="pug">
v-dialog(v-model="dialog" v-if="isAuthenticated" dark :width="500")
  v-card.pa-5
    template(v-if="isRegion")
      p.title.mb-4.text-center.text-uppercase.font-weight-regular
        | Приветствуем Вас в системе "Офис сопровождения Целевой Модели".
      p.mb-2.font-weight-bold Для продолжения работы в системе необходимо:
      ul
        li  указать корректный адрес электронной почты в разделе "Профиль";
        li  установить часовой пояс.
    template(v-else)
      p.title.mb-4.text-center.text-uppercase.font-weight-regular
        | Приветствуем Вас в системе "Офис сопровождения Целевой Модели".
      p Для продолжения работы в системе необходимо указать адрес электронной почты в разделе "Профиль".
    .d-flex.align-center.flex-wrap.mt-4
      v-btn(@click="closeInstruction" color="primary").mr-4 Хорошо
      v-checkbox.ma-0(
        v-model="notShow"
        label="Больше не показывать"
        hide-details
      )
</template>

<script>
import { mapGetters } from 'vuex';

const STORAGE_KEY = 'not-show-instruction';

export default {
  components: {},
  data() {
    return { listToShow:[], notShow: false, dialog: false };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      isRegion: 'auth/isRegion',
      isAuthenticated: 'auth/isAuthenticated',
    }),

    // instruction() {
    //   const instructions = new Map();
    //   instructions.set([ROLES.department], 'Departament');
    //   instructions.set([ROLES.member, ROLES.certificate], 'Member');
    //   instructions.set([ROLES.operator], 'Operator');
    //   instructions.set([ROLES.organization], 'Organization');

    //   // eslint-disable-next-line no-restricted-syntax
    //   for (const key of instructions.keys()) {
    //     if (checkRole(this.userRoles, key)) {
    //       return instructions.get(key);
    //     }
    //   }
    //   return null;
    // },
  },

  created() {
    this.listToShow =  JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (!this.listToShow.includes(this.user.id)) {
      this.dialog = true;
    }
  },
  methods: {
    closeInstruction() {
      if (!this.listToShow.includes(this.user.id)) {
        this.listToShow.push(this.user.id);
      }
      if (this.listToShow.length  > 10) {
        this.listToShow.splice(0, 1);
      }
      this.dialog = false;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.listToShow));
    },
  },
};
</script>

<style></style>
